import { sendRequest } from "handlers/sendRequest";

export const deleteMessage = ({ messageId }) => {
  return sendRequest(
    "delete",
    `/influencer/chat/messages?messageId=${messageId}`,
    {}
  ).then((res) => res.data);
};
